import { combineReducers, createStore } from "redux";
// DEV TOOLS
import reducers from "./reducers";
import react_tools_reducers from "@acri-tools/react-tools/redux/reducers";
// DEV TOOLS
import { composeWithDevTools } from 'redux-devtools-extension';
import react_tools_store from '@acri-tools/react-tools/redux';

const store = createStore(
    combineReducers({
        ...reducers,
        ...react_tools_reducers
    }), composeWithDevTools()
);
// for the react-tools functions
react_tools_store.store = store

export default store;